import { MappableField } from "lib/generated/integration-api";
import MappingCombobox from "./MappingCombobox";

type Props = {
  /** The CRM fields this row can be mapped to, already narrowed to the compatible ones. */
  fields: MappableField[];
  value: string | undefined;
  onChange: (crmField: string | undefined) => void;
  disabled?: boolean;
  label: string;
};

/** Picks the CRM field one application field is written to. */
export default function CrmFieldCombobox({
  fields,
  value,
  onChange,
  disabled,
  label,
}: Props): JSX.Element {
  const options = fields.map((field) => ({
    value: field.id,
    // Both halves, because two fields can share a label and only the column tells them apart.
    label: `${field.name} (${field.id})`,
  }));

  return (
    <MappingCombobox
      options={options}
      value={value}
      onChange={onChange}
      label={`${label} CRM field`}
      placeholder="Select a field"
      searchPlaceholder="Search fields"
      emptyMessage="No matching fields"
      clearLabel={`Clear ${label}`}
      disabled={disabled}
    />
  );
}
